import { Component, Input, inject } from '@angular/core';
import { MarsPrivacyPolicyService } from '@app/core/services/mars-privacy-policy.service';
import { RCAccordionMode, RCAccordionModule } from '@rc/ui';
import {
  SpecificConsentsCheckboxComponentEnum,
  ConsentPurpose,
} from 'src/app/core/models';
import { KeyTranslateLegalConsent } from './consent.config';
import { TranslateModule } from '@ngx-translate/core';
import { DetailTermsKRPrivacyTransferComponent } from '@app/shared/components/detail-terms/detail-terms-kr';
import { DetailTermsKRPrivacyCollectComponent } from '@app/shared/components/detail-terms/detail-terms-kr';
import { MarkdownLinkPipe } from '@app/shared/pipes/markdown-link/markdown-link.pipe';

@Component({
  selector: 'app-detail-terms',
  templateUrl: './detail-terms.component.html',
  styleUrl: 'detail-terms.component.scss',
  imports: [
    RCAccordionModule,
    DetailTermsKRPrivacyCollectComponent,
    DetailTermsKRPrivacyTransferComponent,
    TranslateModule,
    MarkdownLinkPipe,
  ],
})
export class DetailTermsComponent {
  private marsPrivacyPolicyService = inject(MarsPrivacyPolicyService);
  specificConsentsCheckboxComponentEnum = SpecificConsentsCheckboxComponentEnum;

  @Input() consentPurpose!: ConsentPurpose;
  legalConsentText = KeyTranslateLegalConsent['DEFAULT'];
  @Input() set selectedCountry(value: string) {
    this.legalConsentText =
      KeyTranslateLegalConsent[value] ?? KeyTranslateLegalConsent['DEFAULT'];
  }
  RCAccordionMode = RCAccordionMode;

  /**
   * Open terms depending on country selection
   */
  openTermsHref(): string {
    return this.marsPrivacyPolicyService.openTermsHref();
  }
}
